import React, { Fragment } from 'react';
import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap'
import "../styles/custom-styles.css";
import "../styles/responsive.css";

function CompTooltip (props){
        
    var pageTooltip = (data) => (
        <Tooltip id="button-tooltip" {...data}>
            {props.text}
        </Tooltip>
    )

    return (
        <Fragment>
            <div className={'tooltip-field' + (props.error ? " tooltip-field-error" : "")}>
                <OverlayTrigger placement="right" delay={{ show: 250, hide: 400 }} overlay={pageTooltip}>
                    <Form.Label className={props.quesstyle ? "question-style" : null}>{props.title} <i class="bi bi-info-circle"></i></Form.Label>
                </OverlayTrigger>
                {props.error?<span className="error-span-tooltip">{props.error_text}</span>:null}
            </div>
        </Fragment>
    );
};

export default CompTooltip;